/**
 * An enumeration of types accepted by text inputs.
 */
 export enum TextInputType {
  Email = 'email',
  Password = 'password',
  Search = 'search',
  Text = 'text',
  Url = 'url',
}
